export class ConfigConstants {
  static AZURE_SCOPE = import.meta.env.NG_APP_AZURE_SCOPE ?? '';
  static AZURE_AUTHORITY = import.meta.env.NG_APP_AZURE_AUTHORITY ?? '';
  static AZURE_CLIENT_ID = import.meta.env.NG_APP_AZURE_CLIENT_ID ?? '';
  static AZURE_REDIRECT_URI = import.meta.env.NG_APP_AZURE_REDIRECT_URI ?? '';
  static NODE_ENV = import.meta.env.NODE_ENV ?? '';
}
